
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-report",
      function () {
        return require("private-next-pages/battle-report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-report"])
      });
    }
  